import {Speed} from '../../Domain/Speed';

export const getCategoryIndex = (
    categories: Array<{index: number; rangeMin: number; rangeMax: number}>,
    speed: Speed,
): number => {
    const s: number = speed.metersPerSecond;
    return (
        categories.filter((category) => s >= category.rangeMin && s < category.rangeMax)[0] ||
        categories.sort((a, b) =>
            Math.min(Math.abs(s - a.rangeMin), Math.abs(s - a.rangeMax)) <
            Math.min(Math.abs(s - b.rangeMin), Math.abs(s - b.rangeMax))
                ? -1
                : 1,
        )[0]
    ).index;
};
